/* eslint-disable no-unused-vars */
import { useState, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import axios from 'utils/axios/modules/account'
import _ from 'lodash'

function useAccountHook() {
  const [user, setUser] = useState({})
  const [errorDisplay, setErrorDisplay] = useState(false)
  const [isIdle, setIsIdle] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isUpdateSuccess, setIsUpdateSuccess] = useState(false)
  const [errors, setErrors] = useState([])
  const [updateErrors, setUpdateErrors] = useState([])
  const [resultDisplay, setResultDisplay] = useState(false)
  const [approvalDm, setApprovalDm] = useState(false)

  const history = useHistory()

  const execGetUser = useCallback(async () => {
    setIsIdle(false)
    setIsLoading(true)

    await axios
      .getUser()
      .then((response) => {
        // formにそのままいれる関係で、nullをいれるとエラーになるため、空文字に変換する
        _.forEach(response.data.addresses, (value, key) => {
          _.forEach(value, (childValue, childKey) => {
            if (childValue === null) {
              response.data.addresses[key][childKey] = ''
            }
          })
        })

        setUser(response.data)
        setIsSuccess(true)
        setApprovalDm(response.data.approval_dm ? response.data.approval_dm : false)
      })
      .catch((errorMessages) => {
        setErrorDisplay(true)
        setErrors(errorMessages)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  const execUpdateAccountInfo = useCallback(async (values) => {
    setIsUpdating(true)

    const body = {
      phone: values.phone,
      mobile_phone: values.mobilePhone,
      addresses: {
        residence: values.addresses.address1,
        shipping: values.addresses.address2,
      },
      email: values.emailaddress1,
    }

    await axios
      .updateAccountInfo(body)
      .then(() => {
        setResultDisplay(true)
        setIsUpdateSuccess(true)
      })
      .catch((errorMessages) => {
        setErrorDisplay(true)
        setUpdateErrors(errorMessages)
      })
      .finally(() => {
        setIsUpdating(false)
      })
  }, [])

  const execUpdateApprovalDm = async (value) => {
    const body = {
      approval_dm: value,
    }

    await axios
      .updateAccountInfo(body)
      .then(() => {
        setApprovalDm(value)
      })
      .catch((errorMessages) => {
        setErrors(errorMessages)
      })
  }

  const goToUserCreditCardURL = () => {
    const url =
      process.env.REACT_APP_ENV === 'prod'
        ? 'https://shop.tanaka-megane.co.jp/Form/User/UserCreditCardList.aspx'
        : 'https://stg-shop.ninal.jp/Form/User/UserCreditCardList.aspx'
    window.location.href = url
  }

  const goToServiceList = () => {
    history.push('/service')
  }

  const goToEditTanakaId = () => {
    history.push('/id')
  }

  const goToEditAccount = () => {
    history.push('/account/edit')
  }

  return {
    user,
    errorDisplay,
    setErrorDisplay,
    isIdle,
    isLoading,
    isUpdating,
    isSuccess,
    isUpdateSuccess,
    errors,
    updateErrors,
    setErrors,
    setUpdateErrors,
    approvalDm,
    history,
    resultDisplay,
    setResultDisplay,
    execGetUser,
    execUpdateAccountInfo,
    execUpdateApprovalDm,
    goToUserCreditCardURL,
    goToServiceList,
    goToEditAccount,
    goToEditTanakaId,
  }
}

export default useAccountHook
